import { FilterDocument, TaskFilterOptions, User } from '@griply/types';

import {
  transformFilterDocument,
  TransformFilterDocumentOptions,
} from './transform-filter-document';

export type GetFilterDocumentOptionsInput = Omit<
  TransformFilterDocumentOptions,
  'filterDocument' | 'user'
> & {
  filterDocument: FilterDocument | null | undefined;
  user: User | null | undefined;
};

export const getFilterDocumentOptions = (
  input: GetFilterDocumentOptionsInput,
): TaskFilterOptions[] => {
  const { user, filterDocument, ...rest } = input;

  if (!user) {
    return [];
  }

  return transformFilterDocument({
    ...rest,
    user,
    filterDocument: filterDocument ?? {},
  });
};
